import {Component, OnDestroy, Signal} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {ApplicationAppEntityApplicationRead} from '../../../../../../openapi';
import {
  selectApplication,
  selectApplicationState,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import {stages} from '../../placement-advertising.routes';
import {filter, map, Subscription} from 'rxjs';
import {StagesComponent} from '../../../../../../common/stages/stages.component';
import {SpinnerComponent} from '../../../../../../common/spinner/spinner.component';
import {ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {
  AdPlacementRoadOccupationForm,
  occupationsToAdPlacementRoadOccupationFormValues
} from './forms/ad-placement-road-occupation.form';
import {
  AdPlacementRoadOccupationFormComponent
} from './components/ad-placement-road-occupation-form/ad-placement-road-occupation-form.component';
import {
  loadPurposeFeeCollection,
  updateAdPlacementOccupations
} from '../../../../../../store/actions/application.actions';

@Component({
  selector: 'app-ad-placement-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    CommonModule,
    AdPlacementRoadOccupationFormComponent
  ],
  providers: [
    AdPlacementRoadOccupationForm
  ],
  templateUrl: './ad-placement-section.component.html'
})
export class AdPlacementSectionComponent implements OnDestroy {

  public stages: string[] = stages;

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  private fetchApplicationData: Subscription = this.store$.select(selectApplicationState)
    .pipe(filter(v => !v.loading))
    .subscribe((state) => {
      const value = occupationsToAdPlacementRoadOccupationFormValues(state?.application).at(0) || null;
      this.form.patchFormValues({
        value,
        purposeFeeCollection: state.purposeFeeCollection
      });
    });

  private fetchRoadOccupationPurpose: Subscription = this.store$.select(selectApplication)
    .pipe(
      map(v => v?.roadOccupationPurpose?.purposeId || v?.service?.roadOccupationPurposes?.at(0)?.purposeId),
      filter(v => !!v)
    ).subscribe((purposeId) => {
      if (purposeId) {
        this.store$.dispatch(loadPurposeFeeCollection({purposeId}));
      }
    });

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store$: Store,
    public form: AdPlacementRoadOccupationForm
  ) {
  }

  public onCancel(): void {
    this.router.navigate(['../inwestor'], {relativeTo: this.route});
  }

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateAdPlacementOccupations({
          application: this.application(),
          occupations: [this.form.values],
          successFnc: () => {
            this.router.navigate(
              ['../oplaty'],
              {
                relativeTo: this.route
              }
            );
          },
          failureFnc: () => {
          }
        })
      );
    } else {
      this.form.markAllAsTouched();
    }
  }

  public ngOnDestroy(): void {
    this.fetchApplicationData.unsubscribe();
    this.fetchRoadOccupationPurpose.unsubscribe();
  }
}
